export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'ServiceJob';
export const NAME = 'ServiceJob';
